import React from 'react'
import { InfoCircle } from 'react-bootstrap-icons'

interface Props {
    title?: string
    message?: string
    children?: any
}

const EmptyState = ({ title, message, children }: Props) => {
    return (
        <div className='position-relative text-muted p-4'>
            <div className='text-center' style={{minHeight: 300}}>
                <InfoCircle className='fs-3' size={32} />
                <div>
                    {title && <h5 className='fs-5 text-muted fw-bold m-0 ms-3'>{title}</h5>}
                    {message && <p className='fs-6 text-muted m-0 ms-3'>{message}</p>}
                    {children && <>{children}</>}
                </div>
            </div>
        </div>
    )
}

export default EmptyState